import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { http, errorText } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Logo } from "../components/site/Logo";
import { useTitle } from "../lib/useTitle";

export default function AdminLogin() {
  useTitle("Admin sign in | Gait Naurish Ltd.");
  const { user, setUser } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await http.post("/auth/login", { email, password });
      setUser(data);
      nav("/admin");
    } catch (ex) {
      setErr(errorText(ex.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5 bg-[var(--bone)] grain relative">
      <form onSubmit={submit} data-testid="admin-login-form" className="relative w-full max-w-md rounded-[28px] bg-[var(--paper)] border border-[var(--line)] p-8 md:p-10 space-y-6">
        <Logo />
        <h1 className="font-display text-3xl text-[var(--forest)]">Enquiries admin</h1>
        <input data-testid="admin-email-input" type="email" required placeholder="Email" className="field" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-password-input" type="password" required placeholder="Password" className="field" value={password} onChange={(e) => setPassword(e.target.value)} />
        {err && <p data-testid="admin-login-error" className="text-sm text-red-700">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="w-full rounded-full bg-[var(--forest)] text-[var(--bone)] py-3.5 font-semibold inline-flex justify-center items-center gap-2 disabled:opacity-60">
          {busy && <Loader2 size={16} className="animate-spin" />} Sign in
        </button>
      </form>
    </main>
  );
}
